import React, { useContext, useEffect, useState } from 'react'
import { ThemeContext } from '../../auth';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, ButtonGroup, Col, Container, Image, Row, Table } from 'react-bootstrap';
import { LogoFlashklikMrm } from '../../assets';
import ExportExcel from '../../components/ExcelExport';

function Reporting() {

    const { theme } = useContext(ThemeContext);
    const navigate = useNavigate();
    const location = useLocation();
    const { dataReport, start_date, end_date, mode } = location.state || {};

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    useEffect(() => {
        const handleAfterPrint = () => {
            navigate(-1);
        };

        window.addEventListener('afterprint', handleAfterPrint);

        return () => {
            window.removeEventListener('afterprint', handleAfterPrint);
        };
    }, [navigate]);;

    const numberFormat = (value) =>
        new Intl.NumberFormat('IN-ID', {
            style: 'currency',
            currency: 'IDR'
        }).format(value);

    const [showButtons, setShowButtons] = useState(true);

    const handleBack = () => {
        navigate(-1)
    }

    const handleCetak = () => {
        setShowButtons(false);
        setTimeout(() => {
            window.print();
            setShowButtons(true);
        }, 0);
    };

    const grandTotalDivisi = mode === 'Divisi' ? dataReport?.reduce((total, item) => total + (item?.total_cost || 0), 0) || 0 : null;

    const calculateGrandTotal = (dataReport, mode) => {
        if (mode !== 'Anggota') return null;

        let grandTotal = 0;

        Object.values(dataReport).forEach(users => {
            users.forEach(user => {
                grandTotal += user.total_cost;
            });
        });

        return grandTotal;
    };

    const grandTotalAnggota = calculateGrandTotal(dataReport, mode);

    // console.log(grandTotalAnggota)

    const handleExportRowsExcelDataDivisi = () => {
        return dataReport.map((item, index) => ({
            'No.': index + 1,
            'Divisi': item?.group
                ? item.group.charAt(0).toUpperCase() + item.group.slice(1)
                : '',
            'Anggaran': numberFormat(item?.budget || 0),
            'Total': numberFormat(item?.total_cost || 0),
            '% Pemakaian': (item?.usage_percentage.toFixed(2) || 0) + '%,',
        }));
    };

    const handleExportRowsExcelDataAnggota = () => {
        const sheetData = [];
        Object.entries(dataReport).forEach(([division, users]) => {
            users.forEach((user) => {
                sheetData.push({
                    'Divisi': division === "null" ? "Divisi Belum Ada Nama" : division.charAt(0).toUpperCase() + division.slice(1),
                    'Nama': user.first_name.charAt(0).toUpperCase() + user.first_name.slice(1) + ' ' + user.last_name.charAt(0).toUpperCase() + user.last_name.slice(1),
                    'Total': numberFormat(user.total_cost),
                });
            });
        });
        return sheetData;
    };

    // console.log(dataReport)

    return (
        <Container fluid className={showButtons === false ? '' : 'mt-4'} id={theme === 'light' ? 'containerAppLight' : 'containerAppLight'} style={{ width: showButtons === false ? '' : '50%' }}>
            <div style={{ overflowX: 'hidden', maxWidth: '100vw' }}>
                <Container fluid id={theme === 'light' ? 'containerAppLight' : 'containerAppLight'}>
                    <br />
                    <>
                        <div>
                            <Row style={{ maxWidth: '100vw' }}>
                                <Col xs={6} lg={6} className='text-start'>
                                    <div className='pt-3'>
                                        <Image src={LogoFlashklikMrm} width={250} />
                                    </div>
                                </Col>
                                <Col xs={6} lg={6} className='text-end'>

                                </Col>
                            </Row>
                        </div>
                        <div className='mt-4'>
                            <h4 className='text-center mb-3' style={{ fontFamily: 'Poppins-Bold', fontWeight: '800' }}>Laporan per {mode}</h4>
                            <h5 className='text-center mb-3' style={{ fontFamily: 'Poppins-Regular' }}>
                                {formatDate(start_date)} s/d {formatDate(end_date)}
                            </h5>
                            {mode === 'Divisi' ?
                                (
                                    <div>
                                        <Table responsive className='mx-auto' >
                                            <thead>
                                                <tr>
                                                    <th style={{ fontFamily: 'Poppins-Bold', fontSize: '15px' }}>#</th>
                                                    <th style={{ maxWidth: '70px', fontFamily: 'Poppins-Bold', fontSize: '15px' }}>
                                                        Divisi
                                                    </th>
                                                    <th className='text-end' style={{ maxWidth: '70px', fontFamily: 'Poppins-Bold', fontSize: '15px', width: '100px' }}>
                                                        Anggaran
                                                    </th>
                                                    <th className='text-end' style={{ fontFamily: 'Poppins-Bold', fontSize: '15px' }}>Total</th>
                                                    <th className='text-end' style={{ fontFamily: 'Poppins-Bold', fontSize: '15px' }}>% Pemakaian</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dataReport.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className='text-start'
                                                            style={{ fontFamily: 'Poppins-Regular', fontSize: '14px' }}
                                                        >
                                                            {index + 1}
                                                        </td>
                                                        <td
                                                            className='text-start'
                                                            style={{ fontFamily: 'Poppins-Regular', fontSize: '14px', width: '30%', textTransform: 'capitalize' }}
                                                        >
                                                            {item?.group || 'Divisi belum ada nama'}
                                                        </td>
                                                        <td
                                                            className='text-end'
                                                            style={{ fontFamily: 'Poppins-Regular', fontSize: '14px' }}
                                                        >
                                                            {numberFormat(item?.budget || 0)}
                                                        </td>
                                                        <td
                                                            className='text-end'
                                                            style={{ fontFamily: 'Poppins-Regular', fontSize: '14px' }}
                                                        >
                                                            {numberFormat(item?.total_cost || 0)}
                                                        </td>
                                                        <td
                                                            className='text-end'
                                                            style={{ fontFamily: 'Poppins-Regular', fontSize: '14px' }}
                                                        >
                                                            {item?.usage_percentage.toFixed(2) || 0}%
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                )
                                :
                                (
                                    <div>
                                        {Object.entries(dataReport).map(([division, users], divisionIndex) => (
                                            <div key={divisionIndex} className="mb-4">
                                                <h6 style={{ fontFamily: 'Poppins-Bold', textTransform: 'capitalize', marginBottom: '10px' }}>
                                                    {division === "null" ? "Divisi belum ada nama" : division}
                                                </h6>
                                                <Table responsive className='mx-auto'>
                                                    <tbody>
                                                        {users.map((user, userIndex) => (
                                                            <tr key={user.user_id}>
                                                                <td className='text-start' style={{ fontFamily: 'Poppins-Regular', fontSize: '14px' }}>
                                                                    {userIndex + 1}
                                                                </td>
                                                                <td className='text-start' style={{ fontFamily: 'Poppins-Regular', fontSize: '14px' }}>
                                                                    {user.first_name.charAt(0).toUpperCase() + user.first_name.slice(1)} {user.last_name.charAt(0).toUpperCase() + user.last_name.slice(1)}
                                                                </td>
                                                                <td className='text-end' style={{ fontFamily: 'Poppins-Regular', fontSize: '14px' }}>
                                                                    {numberFormat(user.total_cost)}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        ))}
                                    </div>
                                )
                            }
                            {mode === 'Divisi' ?
                                (
                                    <Row className="mt-4">
                                        <Col xs={12} className="text-end">
                                            <h4 style={{ fontFamily: 'Poppins-Bold', fontSize: '20px', fontWeight: '800' }}>Grand total: {numberFormat(grandTotalDivisi)}</h4>
                                        </Col>
                                    </Row>
                                )
                                :
                                (

                                    <Row className="mt-4">
                                        <Col xs={12} className="text-end">
                                            <h4 style={{ fontFamily: 'Poppins-Bold', fontSize: '20px', fontWeight: '800' }}>Grand total: {numberFormat(grandTotalAnggota)}</h4>
                                        </Col>
                                    </Row>
                                )
                            }
                            {showButtons && (
                                <div>
                                    <ButtonGroup>
                                        <Button variant='primary' onClick={handleCetak} style={{ fontFamily: 'Poppins-Regular' }}>Cetak</Button>
                                        <ExportExcel
                                            excelData={mode === 'Divisi' ? handleExportRowsExcelDataDivisi() : handleExportRowsExcelDataAnggota()}
                                            fileName={
                                                mode === 'Divisi' ?
                                                    `Data Laporan per Divisi, ${formatDate(start_date)} s/d ${formatDate(end_date)}`
                                                    :
                                                    `Data Laporan per Anggota, ${formatDate(start_date)} s/d ${formatDate(end_date)}`
                                            }
                                        />
                                        <Button variant='danger' onClick={handleBack} style={{ fontFamily: 'Poppins-Regular' }}>Kembali</Button>
                                    </ButtonGroup>
                                    {/* <Button variant="btn" onClick={handleCetak} className='me-3' style={{ backgroundColor: '#006CB8', fontFamily: 'Poppins-Regular', color: '#FFFFFF' }}>
                                        Cetak
                                    </Button>
                                    <ExportExcel
                                        excelData={mode === 'Divisi' ? handleExportRowsExcelDataDivisi() : handleExportRowsExcelDataAnggota()}
                                        fileName={
                                            mode === 'Divisi' ?
                                                `Data Laporan per Divisi, ${formatDate(start_date)} s/d ${formatDate(end_date)}`
                                                :
                                                `Data Laporan per Anggota, ${formatDate(start_date)} s/d ${formatDate(end_date)}`
                                        }
                                    />
                                    <Button variant="btn" className='ms-3' onClick={handleBack} style={{ backgroundColor: '#464646', fontFamily: 'Poppins-Regular', color: '#FFFFFF' }}>
                                        Kembali
                                    </Button> */}
                                </div>
                            )}
                            <br />
                        </div>
                    </>
                </Container>
            </div>
        </Container>
    )
}

export default Reporting


const customSpinnerStyle = {
    color: '#007bff',
};

